import '../../../App.css'

const Loading = () => <center>
    <div className='loading'>
        <h6>
            <span>L</span>
            <span>o</span>
            <span>a</span>
            <span>d</span>
            <span>i</span>
            <span>n</span>
            <span>g</span>
            <span>.</span>
            <span>.</span>
            <span>.</span>
        </h6>
    </div>
</center>

export default Loading;